module.exports = __webpack_public_path__ + "img/public/SiteIcons/wishlistOff.svg?4613b388";